import Typography from '@ixigo/iui/Typography';
import type { CabUpdateResponse } from '@/api';

interface CabInfoProps {
	cab: NonNullable<CabUpdateResponse['cab']>;
}

export function CabInfo({ cab }: CabInfoProps) {
	return (
		<div className="flex gap-2.5 grow items-center justify-start relative">
			{/* Vehicle Image */}
			<div className="h-40 overflow-hidden relative w-[60px] flex items-center justify-center">
				{cab.imageUrl ? (
					<img
						src={cab.imageUrl}
						alt={cab.name}
						className="max-w-full max-h-full object-contain"
					/>
				) : (
					<div className="bg-tertiary rounded-10 animate-pulse size-full" />
				)}
			</div>

			{/* Vehicle Details */}
			<div className="flex flex-col gap-5 items-start justify-start">
				<Typography variant="body-xs" className="text-secondary">
					{cab.name}
				</Typography>

				{/* License Number Chip */}
				<div className="bg-[#FFE794] text-common-black border border-primary flex gap-x-0.5 items-center justify-center px-5 py-0.5 rounded-5">
					<div className="size-0.5 bg-common-black rounded-full" />
					<Typography variant="body-xs" className="font-medium">
						{cab.licenseNumber}
					</Typography>
					<div className="size-0.5 bg-common-black rounded-full" />
				</div>
			</div>
		</div>
	);
}
